import type { UseQueryResult } from "@tanstack/react-query";

import { useUnscopedQuery } from "../../query/scope";
import { fetchHealthz } from "./api";
import type { HealthzResponse } from "./api";

// Хук TanStack Query вокруг `fetchHealthz`. Unscoped запрос (см.
// `src/query/scope.ts`) — проба ничья, идёт и без identity.
//
// `enabled: false` — запрос не стартует автоматически при mount'е;
// пользователь должен нажать кнопку «Проверить backend» (явный тык —
// явный запрос). Упрощает тесты: компонент стартует без сетевого
// вызова в фоне.
//
// `retry: false` — на первый раз показываем ошибку без молчаливых
// повторов. Проба намеренно не несёт таксономии ошибок (см.
// `docs/spec/core/health.md`): она либо отвечает `200`, либо запрос
// падает соединением — различать причины отказа нечем.
export function useHealthz(): UseQueryResult<HealthzResponse, Error> {
  return useUnscopedQuery<HealthzResponse>({
    key: ["healthz"],
    queryFn: fetchHealthz,
    enabled: false,
    retry: false,
  });
}
